<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_white.png" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index != 0 && index == navIndex ? 'active' : ''"
          @click="navClick(index, item.label)"
        >
          <!-- <router-link :to="item.props.path"> -->
          <!-- <router-link>
            {{item.label}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link> -->
          <a @click="openHome(item)" class="firstLevelMenu">
            {{ item.label }}
            <span
              v-if="item.children && item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <!-- <i class="underline"></i> -->
          </a>
          <dl v-if="item.children && item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <!-- <router-link>{{i.label}}</router-link> -->
              <div @click="openPage(i)" class="secondLevelMenu">
                {{ i.label }}
              </div>
              <!-- <router-link :to="i.props.path">{{i.label}}</router-link> -->
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-bar">
        <div class="header-nav-m-logo">
          <img
            class="center-block"
            src="@/assets/img/logo_black.png"
            alt="logo"
          />
        </div>
        <div class="header-nav-m-icon" @click="toggleMenu()">
          <i></i>
          <i></i>
          <i></i>
        </div>
      </div>
      <!-- 导航栏 -->
      <div class="m-menu" :class="menuTurnOn">
        <div class="menu-left" @click="closeMenu()"></div>
        <div class="menu-right">
          <div class="header-nav-m-menu">
            {{ menuName }}
            <div class="header-nav-m-menu-wrapper" @click="menuClick">
              <span :class="menuClass"></span>
            </div>
            <!-- 导航内容 -->
            <ul id="menu" class="header-nav-m-wrapper">
              <li
                v-for="(item, index) in navList"
                :key="index"
                :class="index == navIndex ? 'active' : ''"
                @click="navClick(index, item.label)"
                data-toggle="collapse"
              >
                <div v-if="item.label == '首页'" @click="openPage(item)">
                  {{ item.label }}
                  <i class="underline"></i>
                </div>
                <div v-else>
                  {{ item.label }}
                  <i class="underline"></i>
                </div>
                <div class="sub-menu">
                  <dl v-if="item.children && item.children.length > 0">
                    <dt v-for="(i, n) in item.children" :key="n">
                      <!-- <router-link>{{i.label}}</router-link> -->
                      <div @click="openPage(i)" class="secondLevelMenu">
                        {{ i.label }}
                      </div>
                      <!-- <router-link :to="i.props.path">{{i.label}}</router-link> -->
                    </dt>
                  </dl>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCatalogData } from "@/api/apiRequest";
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      menuTurnOn: "off",
      subMenu: "subMenu",
      dataList: [],
      navList: [
        // {
        //   label: "首页",
        //   path: "/",
        //   children: []
        // },
        // {
        //   name: "关于我们",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "公司简介",
        //       path: "/aboutus/companyintroduce"
        //     },
        //     {
        //       name: "公司文化",
        //       path: "/aboutus/companyculture"
        //     },
        //     {
        //       name: "资质荣誉",
        //       path: "/aboutus/qualificationhonor"
        //     },
        //     {
        //       name: "发展历程",
        //       path: "/aboutus/develophistory"
        //     },
        //     {
        //       name: "合作伙伴",
        //       path: "/aboutus/partners"
        //     },
        //     {
        //       name: "联系我们",
        //       path: "/aboutus/contactus"
        //     }
        //   ]
        // },
        // {
        //   name: "核心业务",
        //   path: "/service",
        //   children: [
        //   {
        //       name: "人力资源派遣",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "人力资源外包",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "船员合作",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "技能培训",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "境外就业",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "招聘服务",
        //       path: "/software/bigData"
        //     }
        //   ]
        // },
        // {
        //   name: "服务中心",
        //   path: "/newsinformation",
        //   children: [ {
        //       name: "工资查询",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "社保查询",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "医保查询",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "公积金查询",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "证书查询",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "办事指南",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "服务预约",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "投诉建议",
        //       path: "/software/bigData"
        //     }]
        // },
        // {
        //   name: "公司动态",
        //   path: "/companyintroduction",
        //   children: [{
        //       name: "公司动态",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "公告通知",
        //       path: "/software/bigData"
        //     },
        //     {
        //       name: "党建动态",
        //       path: "/software/bigData"
        //     }]
        // }
      ],
    };
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    scrollToTop() {
      // 页面滚动的动画效果
      window.scrollTo({
        top: 0, // 滚动到页面顶部
        behavior: "smooth", // 平滑滚动
      });
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    toggleMenu() {
      if (this.menuTurnOn === "on") {
        this.menuTurnOn = "off";
      } else {
        this.menuTurnOn = "on";
      }
    },
    toggleSubMenu() {
      if (this.subMenuTurnOn === "on") {
        this.subMenuTurnOn = "off";
      } else {
        this.subMenuTurnOn = "on";
      }
    },
    closeMenu() {
      this.menuTurnOn = "off";
    },
    openHome(item) {
      if (item.label == "首页") {
        this.$router.push({
          name: "home",
        });
      }
    },
    openPage(item) {
      this.closeMenu();
      if (item.props.catalogType == "link" && item.props.redirectUrl != "") {
        window.open(item.props.redirectUrl, "_blank");
      } else {
        let queryData = null;
        if (item.props.openType == 1 && item.props.contentId != "") {
          queryData = {
            contentType: item.props.contentType,
            catalogId: item.id,
            contentId: item.props.contentId,
          };
        } else {
          queryData = { catalogId: item.id };
        }
        this.$router.push({
          name: item.props.path,
          query: queryData,
        });
        this.scrollToTop();
        // if(queryData!=null)
        // {
        //   this.$router.push({
        //     name: item.props.path,
        //     query:queryData
        //   });
        // }
        // else{
        //   this.$router.push({
        //     name: item.props.path,
        //   });
        // }
        sessionStorage.setItem("catalogId", item.id);
      }
    },
    getData() {
      getCatalogData().then((res) => {
        let dataList = res.data.data.rows;
        this.navList = [];
        dataList.forEach((item, index) => {
          this.navList.push(item);
        });
      });
    },
  },
};
</script>
<style>
/* 顶部 */
#header {
  position: relative;
  width: 100%;
  height: 110px;
  background: rgba(255, 255, 255, 0.3);
  transition: all ease 0.6s;
  z-index: 10;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 240px;
  height: 73px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #444;
  font-size: 17px;
  font-weight: bold;
  padding: 46px 25px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #fff;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #fff;
  background: linear-gradient(180deg, #2896d3 10%, #08367a);
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #fff;
  background: linear-gradient(180deg, #2896d3 10%, #08367a);
  text-decoration: none;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 135px;
  top: 100%;
  left: 0;
  z-index: 999999;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(6px);
  text-align: center;
  animation: slide-up 0.5s ease-in-out forwards;
  transform: translateY(10px);
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  font-size: 15px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #08367a;
  color: #fff;
  border-bottom: 1px solid #08367a;
}
@keyframes slide-up {
  from {
    transform: translateY(10px);
  }
  to {
    transform: translateY(0);
  }
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  #header .header-nav .header-nav-wrapper > li > a {
    padding: 46px 15px;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }

  #header .header-nav.container {
    width: 100%;
  }
}
/* mobile nav start*/
@media screen and (max-width: 767px) {
  #header {
    height: 68px;
  }
  #header .header-nav-m .header-nav-m-wrapper,
  #header .header-nav-m .header-nav-m-menu {
    background-color: transparent;
    color: #333;
    padding-left: 25px;
    font-weight: bold;
  }
}
.header-nav-m-icon {
  float: right;
}
.header-nav-m-icon i {
  border-bottom: 2px solid #0a1e42;
  height: 7px;
  display: block;
  width: 25px;
}
.header-bar {
  height: 68px;
  display: flex;
  justify-content: space-between;
  padding: 0px 10px;
  align-items: center;
  cursor: pointer;
}
.m-menu {
  display: flex;
}
.menu-left {
  display: block;
  width: 30%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 101;
}
.menu-right {
  width: 70%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 120;
  overflow: hidden;
  background: #cce0f4;
  color: rgba(255, 255, 255, 0.6);
}
.m-menu.off,
.m-menu .sub-menu.off {
  display: none;
}
.m-menu.on .m-menu .sub-menu.on {
  display: block;
}
.m-menu .sub-menu {
  display: none;
}
.m-menu .active .sub-menu {
  display: block;
}
.sub-menu {
  padding-left: 25px;
}

/* mobile nav end*/

.firstLevelMenu {
  cursor: pointer;
  color: #444;
  font-size: 18px;
  font-weight: 600;
  padding: 0 25px;
}
.secondLevelMenu {
  line-height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue